import React, {useMemo} from 'react'
import ReportSubtitleV1 from 'components/Text/ReportSubtitleV1'
import ReportSubtitle from 'components/Text/ReportSubtitle'
import useLanguage from 'features/languageReport/useLanguage'
import useStyles from 'components/molcules/N1SummaryReport/useStyles'

import {
  CommentContainer,
  CommentDiscussion,
  CommentDivider,
  CommentTag,
  SectionTitle,
} from './Style'

export default function EEGSummaryBrainBalanceDevelopmentAPI(props: {
  brainBalance3dImage: string | undefined
  brainBalanceImage: string | undefined
  LH: number
  RH: number
  isSummary?: boolean
}) {
  const {brainBalance3dImage, brainBalanceImage, LH, RH, isSummary} = props
  const classes = useStyles()
  const {textEegAPI} = useLanguage('eeg')

  const discussionType = useMemo(() => {
    if (!textEegAPI) return ''
    if (LH >= 50 && RH >= 50) {
      return textEegAPI.infant_youth.section.brain_balance.analysis_results
        .class.balanced
    }
    if (LH >= 50 && RH < 50) {
      return textEegAPI.infant_youth.section.brain_balance.analysis_results
        .class.left
    }
    if (LH < 50 && RH >= 50) {
      return textEegAPI.infant_youth.section.brain_balance.analysis_results
        .class.right
    }
    if (LH < 50 && RH < 50) {
      return textEegAPI.infant_youth.section.brain_balance.analysis_results
        .class.weak
    }
    return ''
  }, [textEegAPI])

  return (
    <div className={classes.eeg}>
      {isSummary ? (
        <ReportSubtitleV1 number='4'>
          {textEegAPI?.infant_youth.section.brain_balance.title}
        </ReportSubtitleV1>
      ) : (
        <ReportSubtitle number='4'>
          {textEegAPI?.infant_youth.section.brain_balance.title}
        </ReportSubtitle>
      )}

      <div className={classes.childValueGraphHalf}>
        <div className='Child-info'>
          <SectionTitle className='Title'>
            {textEegAPI?.infant_youth.section.brain_balance.description.main}
          </SectionTitle>
          <div className='Desc' style={{color: '#333333'}}>
            {textEegAPI?.infant_youth.section.brain_balance.description.sub[0]}
            <br />
            {textEegAPI?.infant_youth.section.brain_balance.description.sub[1]}
          </div>
        </div>

        <div className='Child-Graph-Box'>
          <div className='Child-Graph' style={{flex: 6}}>
            {/* eslint-disable-next-line jsx-a11y/img-redundant-alt */}
            <img
              src={brainBalance3dImage}
              alt='brain wave analysis 3d image'
              style={{marginTop: 30}}
            />
          </div>
          <div className='Child-Graph' style={{flex: 4}}>
            {/* eslint-disable-next-line jsx-a11y/img-redundant-alt */}
            <img src={brainBalanceImage} alt='brain wave analysis 3d image' />
          </div>
        </div>
        <div>
          <CommentTag>
            {
              textEegAPI?.infant_youth.section.brain_balance.analysis_results
                .title
            }
          </CommentTag>
          <CommentDivider />

          <CommentContainer>
            <CommentDiscussion>
              {/* IEEGSummaryReportChildBrainBalanceResultDescAPI */}
              {textEegAPI?.infant_youth.section.brain_balance.analysis_results.comments
                .replace('{0}', LH.toString())
                .replace('{1}', RH.toString())
                .replace('{2}', discussionType)}
            </CommentDiscussion>
          </CommentContainer>
        </div>
        <div className='Child-info-alert' style={{marginBottom: '25px'}}>
          {
            textEegAPI?.infant_youth.section.brain_balance.analysis_results
              .annotation
          }
        </div>
      </div>
    </div>
  )
}
